import React from "react";
import { FormattedMessage } from "react-intl";

const PRODUCT_TASTE_LANG_KEYS = {
  "1-009-01": {
    // dtf_id: 元盅雞麵
    74: "popup.ChickenNoodlesSeparate", //雞湯麵分
    86: "popup.ChickenNoodlesNoSeparate", //雞湯麵合
  },
  "1-009-02": {
    // dtf_id: 元盅牛肉麵
    74: "popup.BeefNoodlesSeparate", // 牛肉湯麵分
    86: "popup.BeefNoodlesNoSeparate", // 牛肉湯麵合
  },
};

/**
 * 顯示特口的多國語系文字
 * @param stayInTaste 特口物件
 * @returns
 */
export const getSpecificTasteDisplay = (taste, product) => {
  if (taste.id === 41) {
    //隨餐上
    return (
      <span>
        <FormattedMessage id="popup.buttonDuringTheMeal" />
      </span>
    );
  }
  if (taste.id === 411) {
    //餐後上
    return (
      <span>
        <FormattedMessage id="popup.buttonAfterTheMeal" />
      </span>
    );
  }
 
  if (
    !!product.dtf_id &&
    !!PRODUCT_TASTE_LANG_KEYS[product.dtf_id] &&
    !!PRODUCT_TASTE_LANG_KEYS[product.dtf_id][taste.id]
  ) {
    // 產品的特口是否有多國語系文字 有的話就回傳對應的多國語系文字
    return (
      <span>
        <FormattedMessage id={PRODUCT_TASTE_LANG_KEYS[product.dtf_id][taste.id]} />
      </span>
    );
  }

  return `${taste.name}`;
};
